// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wtva9","label":"styles_label__1oYdc"};